import { SystemStyleObject } from "@chakra-ui/react";

// SettlementManagementCalendar의 FullCalendar 커스텀 스타일
export const settlementCalendarSx: SystemStyleObject = {
  // 기본 헤더 숨기기 (커스텀 헤더 사용)
  ".fc .fc-toolbar": {
    display: "none",
  },
  // 테이블 테두리
  ".fc": {
    fontFamily: "inherit",
  },
  ".fc .fc-scrollgrid": {
    border: "none",
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "24px",
  },
  // 외곽 셀의 border 제거 (wrapper Box의 border와 겹침 방지)
  ".fc-scrollgrid-section-header tr": {
    borderBottom: "1px solid #D4D4D1",
  },
  ".fc-scrollgrid-section-header th": {
    border: "none", // 모든 th에서 테두리 제거
  },
  ".fc .fc-scrollgrid td": {
    border: "none",
  },
  ".fc-scrollgrid-section-body tr:first-of-type": {
    borderTop: "1px solid #D4D4D1",
  },
  ".fc .fc-scrollgrid tr:not(:last-child) td": {
    borderBottom: "1px solid #D4D4D1",
  },
  ".fc .fc-col-header-cell": {
    padding: "2px 0",
    backgroundColor: "#FFFFFF",
    borderColor: "#D4D4D1",
    textAlign: "start",
    paddingLeft: "8px",
  },
  // 일요일 날짜 숫자 빨간색
  ".fc .fc-daygrid-day.fc-day-sun .fc-daygrid-day-number": {
    color: "#CC1D1D",
  },
  ".fc .fc-daygrid-day .fc-daygrid-day-number": {
    color: "#444444",
  },
  // 셀 높이
  ".fc .fc-daygrid-day": {
    minHeight: "100px",
    backgroundColor: "#FFFFFF",
  },
  ".fc .fc-daygrid-day-frame": {
    minHeight: "100px",
  },
  // 이벤트 스타일
  ".fc .fc-daygrid-event": {
    borderRadius: "6px",
    border: "none",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "24px",
    margin: "2px 4px",
    marginTop: "0px",
    textAlign: "center",
  },
  ".fc .fc-daygrid-event:hover": {
    background: "none",
  },
  // 청구일 이벤트 스타일
  ".fc .fc-daygrid-event:has(.billing-date-event)": {
    backgroundColor: "#FEDCDC !important",
  },
  // 오늘 날짜 배경
  ".fc .fc-day-today": {
    backgroundColor: "#FFFFFF !important",
  },
  ".fc .fc-day-today .fc-daygrid-day-number": {
    backgroundColor: "#1A202C",
    color: "#fff",
    borderRadius: "50%",
    width: "28px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  // 이전/다음 달 날짜 흐리게
  ".fc .fc-day-other .fc-daygrid-event": {
    opacity: 0.3,
  },
  // 날짜 숫자 위치
  ".fc .fc-daygrid-day-top": {
    display: "flex",
    justifyContent: "start",
    padding: "4px 0",
    paddingLeft: "8px",
    paddingBottom: "0px",
  },
  ".fc .fc-daygrid-day-number": {
    fontSize: "14px",
    fontWeight: "500",
  },
  // 셀 테두리
  ".fc td, .fc th": {
    borderColor: "#D4D4D1",
  },
  // 더보기 모달
  ".fc-more-popover": {
    width: "var(--day-cell-width)",
    border: "none",
    borderRadius: "8px",
    padding: "8px 12px",
  },
  ".fc-more-popover .fc-popover-title": {
    fontSize: "clamp(12px, calc(var(--day-cell-width, 156px) * 0.12), 14px)",
    fontWeight: 700,
    color: "#444444",
  },
  ".fc-more-popover .fc-popover-header": {
    background: "none",
  },
  ".fc-more-popover .fc-popover-header .fc-popover-close": {
    color: "#8F8F8C",
  },
  ".fc-more-popover .fc-popover-header .fc-popover-close:hover": {
    color: "#1272EF",
  },
  ".fc-more-popover .fc-popover-header .fc-popover-close:active": {
    color: "#00417D",
  },
  ".fc-more-popover .fc-popover-body": {
    minWidth: 0,
    padding: 0,
    paddingTop: "6px",
  },
  ".fc-popover-body .fc-daygrid-event-harness:has(.billing-date-event)": {
    display: "none",
  },
  // 더보기 텍스트
  ".fc-daygrid-day-bottom": {
    display: "flex",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "700",
    color: "#444444",
  },
  ".fc .fc-daygrid-more-link": {
    fontSize: "12px",
    color: "#444444",
    fontWeight: 700,
    padding: "2px 4px",
  },
  ".fc .fc-daygrid-more-link:hover": {
    background: "inherit",
    color: "#1272EF",
  },
  ".fc .fc-daygrid-more-link:active": {
    background: "inherit",
    color: "#00417D",
  },
};
